/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimulationOperationResult
 */
export interface SimulationOperationResult {
    /**
     * 
     * @type {boolean}
     * @memberof SimulationOperationResult
     */
    versionCreated?: boolean;
}

/**
 * Check if a given object implements the SimulationOperationResult interface.
 */
export function instanceOfSimulationOperationResult(value: object): value is SimulationOperationResult {
    return true;
}

export function SimulationOperationResultFromJSON(json: any): SimulationOperationResult {
    return SimulationOperationResultFromJSONTyped(json, false);
}

export function SimulationOperationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationOperationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'versionCreated': json['versionCreated'] == null ? undefined : json['versionCreated'],
    };
}

export function SimulationOperationResultToJSON(json: any): SimulationOperationResult {
    return SimulationOperationResultToJSONTyped(json, false);
}

export function SimulationOperationResultToJSONTyped(value?: SimulationOperationResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'versionCreated': value['versionCreated'],
    };
}

